import lodash from "lodash"

export function getVolume(values) {
  const height = Number(lodash.get(values, "height", 0))
  const width = Number(lodash.get(values, "width", 0))
  const length = Number(lodash.get(values, "length", 0))
  return (height * width * length) / 1000000
}

export function getGirthLength(values) {
  const height = Number(lodash.get(values, "height", 0))
  const width = Number(lodash.get(values, "width", 0))
  const length = Number(lodash.get(values, "length", 0))
  const obj = { height, width, length }
  const mapped = lodash.keys(obj).map(key => ({
    value: Number(obj[key]),
    key
  }))
  const sides = lodash
    .orderBy(mapped, ["value"], ["desc"])
    .map(item => item.value)
  return sides[0] + sides[1] * 2 + sides[2] * 2
}
